import slug from 'constants/slug'
import createBreadcrumb from 'shared/breadcrumb/hoc'
//import Icon from 'themes/icon'

export default createBreadcrumb({
  list: {
    id: 'list',
    //icon: Icon.car,
    href: slug.languageLocale.list,
    name: 'Language locale'
  },
  create: {
    id: 'create',
    href: slug.languageLocale.create,
    name: 'Create'
  },
  edit: {
    href: slug.languageLocale.edit,
    name: 'Update'
  }
})



// WEBPACK FOOTER //
// ./src/containers/language-locale/breadcrumb.js